import { Header } from '../header/header';
import { ZoomHeader } from '../zoom-header/ZoomHeader';

interface Props {
  myAccount: any;
  productCategories: any;
}
export const HeaderByAppType = ({ myAccount, productCategories }: Props) => {
  const isZoomPage = window.location.pathname.startsWith('/zoom');

  if (isZoomPage) {
    return <ZoomHeader />;
  }
  return <Header myAccount={myAccount} productCategories={productCategories} />;
};
